import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    question: "Is this an age specific Mobile Home and RV Park?",
    answer: "We are an exclusive 55+ Mobile Home and RV Park during the seasonal months from (Oct-May). In the off-season summer months from (Jun-Sep), we will allow guests and families under the age requirement to enjoy a limited stay at the Park. All guests are subject to Park rules and Management approval."
  },
  {
    question: "What are the nightly rates?",
    answer: "Nightly rates are as follows (local taxes apply): (1-2) people - $40.00, (3-4) people - $45.00, (5-7) people - $50.00, (8-10) people - $60.00"
  },
  {
    question: "What are the monthly rates?",
    answer: "We offer competitive monthly and seasonal rates, making us an ideal spot for snowbirds. Monthly rate for a small lot (25'-35' W x 50' L) is $380.00. Monthly rate for a large lot (25'-35' W x 75' L) is $395.00. Local taxes apply."
  },
  {
    question: "Do you require a deposit to reserve a space?",
    answer: "Yes, we require a $50.00 deposit for a long term stay. No deposit required for an overnight stay. Cancellations must be 48-hours in advance to receive a full refund of the deposit."
  },
  {
    question: "Are you a pet friendly Park? What restrictions if any?",
    answer: "For Tenant's safety, we only allow small breed dogs. Any dog allowed in the park must be smaller than 25 lbs and no taller than 17\" at the shoulder. No aggressive breeds (ie) pitbulls, rottweilers, dobermans, german shepherds, poodles etc. All permitted dogs will need to be on a leash, and Tenants are responsible for cleaning up after their dogs. There is a limit of 2 dogs per space. A designated dog run is available in the park as well. Indoor cats are welcome, no large parrots or reptiles are allowed."
  },
  {
    question: "What are the hours of operation?",
    answer: "Office Hours: M-F 9:00 am to 4:00 pm, Sat. 9:00 am to 3:00 pm, Sun. CLOSED. Check-in after 12:00 pm, Check-out before 11:00 am. (After hours self check-in available)"
  },
  {
    question: "Are there any restrictions on Mobile Homes or RV's?",
    answer: "Yes, at the Fun 'n Sun Mobile Home and RV Park, we strive to maintain a standard. All new Tenants are subject to approval by Management. Tenants may need to provide a picture of your Mobile Home or RV to Management before checking in."
  },
  {
    question: "Are there any mobile homes or RV's available for rent?",
    answer: "No, there are not any mobile homes or RV's for rent in the Park."
  },
  {
    question: "Do you have a designated dump station for sewer?",
    answer: "We do not have a designated dump station for sewer. Only Tenants who book an overnight stay can dump in their designated spaces."
  },
  {
    question: "Do you have a designated fill up station for water?",
    answer: "We do offer water filling services for travelers passing through for $10.00"
  }
];

export function FAQSection() {
  return (
    <section id="faq" className="py-20 bg-muted/30">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Find answers to common questions about staying at Fun 'n Sun Mobile Home & RV Park
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white rounded-lg border shadow-sm"
              >
                <AccordionTrigger className="px-6 py-4 text-left hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-muted-foreground leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        <div className="text-center mt-12">
          <p className="text-muted-foreground mb-4">
            Have more questions? We're here to help!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="tel:+17023978894" className="text-primary hover:underline">
              Call us at (702) 397-8894
            </a>
            <span className="hidden sm:block text-muted-foreground">•</span>
            <a href="mailto:fun_n_sun@mvdsl.com" className="text-primary hover:underline">
              Email fun_n_sun@mvdsl.com
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}